import axios from "axios";
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  FaFilter,
  FaSort,
  FaEllipsisV,
  FaArrowLeft,
  FaArrowRight,
  FaTimes,
  FaEdit,
  FaShareAlt,
  FaGoogleDrive,
  FaFileAlt,
  FaChartBar,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { openPricing } from '../../utils/openPricing'
import { IpInfoResponse } from "../../types/authTypes";
import { Plan } from "../../types/pricingTypes";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import PaymentGateway from "../payment/PaymentGateway";

import { useDispatch } from "react-redux";
import { setUserPlan } from "../../redux/slices/userSlice";
import HistoryThumbnail from "./HistoryThumbnail";
import { PricingModalNew } from "../shared/PricingModalNew";
import {
  getStaticPricing,
  getStaticPricingBundle,
} from "../../utils/pricingConfig";

function getSheetIdFromUrl(url: string) {
  const match = url.match(/\/d\/(.+?)\/|\/open\?id=(.+?)(?:&|$)/);
  return match ? match[1] || match[2] : null;
}

const HistoryContainer: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isSortModalOpen, setIsSortModalOpen] = useState(false); // State for sort modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [documentsData, setDocumentsData] = useState<any[]>([]); // Separate state for documents
  const [filteredData, setFilteredData] = useState<any[]>([]); // Holds filtered data
  const [selectedFilter, setSelectedFilter] = useState<string>("all"); // Filter state
  const [selectedSort, setSelectedSort] = useState<string>("recent"); // Sort state
  const [isLoading, setIsLoading] = useState(false);
  const userId = sessionStorage.getItem("userEmail");
  const historyUrl = process.env.REACT_APP_BACKEND_URL || "";
  const authToken = sessionStorage.getItem("authToken");
  const orgId = sessionStorage.getItem("orgId");
  const navigate = useNavigate();
  const userPlan = useSelector((state: any) => state.user.userPlan);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [pricingModalHeading, setPricingModalHeading] = useState("");
  const [monthlyPlan, setMonthlyPlan] = useState<Plan>();
  const [yearlyPlan, setYearlyPlan] = useState<Plan>();
  const [currency, setCurrency] = useState("");
  const [documentID, setDocumentID] = useState<string | null>(null);
  const [paid, setIsPaid] = useState(false);
  const [subId, setSubId] = useState("");
  const dispatch = useDispatch();
  const [visibleSlides, setVisibleSlides] = useState<Set<number>>(new Set());
  const containerRef = useRef<HTMLDivElement>(null);
  const [isDiscounted, setIsDiscounted] = useState(false);
  const [isBundle, setIsBundle] = useState(false);
const [totalPages, setTotalPages] = useState(1);
  const [activeTab, setActiveTab] = useState<'slides' | 'docs'>('slides');

  const currentCurrency = sessionStorage.getItem("currency");
  const pricing = getStaticPricing(currentCurrency === "INR" ? "INR" : "USD"); // ✅ get dynamic prices
  const discountedAmount = pricing.original; // 49 or 1
  const currentAmount = pricing.current; // 99 or 2

  const bundlePricing = getStaticPricingBundle(
    currentCurrency === "INR" ? "INR" : "USD"
  );
  const bundleDiscountedAmount = bundlePricing.original;
  const bundleCurrentAmount = bundlePricing.current;
  useEffect(() => {
    console.log("Bundle or discount changed");
  }, [isBundle, isDiscounted]);

  const openPricingModal = async () => {
    // Redirect to external pricing page instead of opening in-app modal
    openPricing('history');
    try {
      // Update the export status
      const updatePaymentStatus = async () => {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/finalsheet/${documentID}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({ exportstatus: true }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        console.log("Payment status updated:", result);
      };

      // Call payment status update
      await updatePaymentStatus();
    } catch (error) {
      console.log(error);
    }
  };

  // Handle Download Button Click
  const handleDownload = async (decrementBundle: boolean = false) => {
    try {
      const formId = documentID;
      if (!formId) {
        throw new Error("Form ID not found in localStorage");
      }

      if (!paid) {
        // 1. First, update the payment status
        const updatePaymentStatus = async () => {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/finalsheet/${documentID}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
              body: JSON.stringify({ paymentStatus: 1, exportstatus: true }),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const result = await response.json();
          console.log("Payment status updated:", result);
        };

        // Call payment status update
        await updatePaymentStatus();

        // 2. Then, call the additional API to get presentationID
        const callAdditionalApi = async () => {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/slides/presentation?formId=${formId}`
          );
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          console.log("Additional API response:", result);

          const presentationID = result.PresentationID; // Extract PresentationID from response

          if (presentationID) {
            // Call the second API with the extracted presentationID
            const secondApiResponse = await fetch(
              `https://script.google.com/macros/s/AKfycbyUR5SWxE4IHJ6uVr1eVTS7WhJywnbCNBs2zlJsUFbafyCsaNWiGxg7HQbyB3zx7R6z/exec?presentationID=${presentationID}`
            );
            const secondApiText = await secondApiResponse.text();
            console.log("Raw second API response:", secondApiText);

            try {
              const secondApiResult = JSON.parse(secondApiText);
              console.log("Second API parsed response:", secondApiResult);
            } catch (jsonError) {
              console.error(
                "Error parsing second API response as JSON:",
                jsonError
              );
            }
          } else {
            throw new Error("PresentationID not found in the response");
          }
        };

        // Call additional API
        await callAdditionalApi();
      }

      // 3. Finally, call the original slides URL API
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/statuscheck/${documentID}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      const url = result.data.PresentationURL;

      if (!url || typeof url !== "string") {
        throw new Error("Invalid URL in response");
      }

      // Open URL based on device type
      if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
        // Mobile: Open in the same tab
        window.location.href = url;
      } else {
        // Desktop: Open directly in a new tab
        window.open(url, "_blank");
      }
      if (isBundle) {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({ bundle: 3 }),
          }
        );
        setIsBundle(false);
        if (!(response.status == 200)) {
          throw new Error(`Bundle not updated`);
        }
      }
      const getOrgProfile = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (getOrgProfile.status !== 200) {
        console.error("Non-200 response:", getOrgProfile.status);
        return;
      }
      const bundle = getOrgProfile.data.bundle;
      console.log(bundle);
      const changeBundle = decrementBundle ? bundle - 1 : bundle;
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ bundle: changeBundle }),
        }
      );
      setIsPricingModalOpen(false);
    } catch (error) {
      console.error("Error exporting presentation:", error);
      alert(
        "Oops! It seems like the pitch deck presentation is missing. Click 'Generate Presentation' to begin your journey to success!"
      );
    }
  };

  // Function to check payment status and proceed
  // const checkPaymentStatusAndProceed = async () => {
  //   console.log(isBundle);
  //   const paymentButton = document.getElementById("payment-button");

  //   if (paymentButton) {
  //     paymentButton.click();
  //   } else {
  //     console.error("Payment button not found");
  //   }
  // };

  const checkPaymentStatusAndProceed = (bundle: boolean) => {
    setIsBundle(bundle);
  
    // Wait for isBundle state to update before triggering Razorpay
    setTimeout(() => {
      const paymentButton = document.getElementById("payment-button");
      if (paymentButton) {
        paymentButton.click();
      } else {
        console.error("Payment button not found");
      }
    }, 0);
  };
  

  // const presentationsToShow = filteredData?.slice(
  //   (currentPage - 1) * 10,
  //   currentPage * 10
  // );

  // Handle Share Button Click
  const handleShare = async () => {
    const url = `/presentation-share?formId=${documentID}`;
    window.open(url, "_blank"); // Opens the URL in a new tab
  };

  const handleEdit = (documentID: string, name: string, itemType?: string) => {
    if (itemType === 'Document') {
      navigate(`/documentview?documentID=${documentID}`);
    } else {
      navigate(
        `/presentation-view?documentID=${documentID}&presentationName=${name}`
      );
    }
  };

  // Handle clicks and scroll to close dropdown
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      // Close the dropdown if the click is outside of both the dropdown and tooltip
      if (
        activeDropdown !== null &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setActiveDropdown(null); // Close dropdown if click is outside both
      }
    };

    const handleScroll = () => setActiveDropdown(null);

    document.addEventListener("click", handleOutsideClick);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeDropdown]); // Effect runs when activeDropdown changes

  // API CALL TO GET HISTORY DATA & API CALL TO GET PRICING DATA FOR MODAL AND USER PLAN
  useEffect(() => {
    setIsLoading(true);

const fetchSlidesData = async () => {
  try {
    const response = await fetch(
      `${historyUrl}/api/v1/data/slidedisplay/history/${userId}?page=${currentPage}&limit=10`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    const result = await response.json();

    if (!Array.isArray(result.data)) {
      console.warn("No slides data found.");
      setHistoryData([]);
      return;
    }

    // Set slides data (excluding documents)
    const slidesOnly = result.data.filter(
      (item: { ppt_type?: string }) => item.ppt_type !== "Document"
    );
    setHistoryData(slidesOnly);

    // If backend sends pagination info:
    if (result.pagination) {
      setTotalPages(result.pagination.totalPages || 1);
    } else {
      // fallback
      setTotalPages(slidesOnly.length < 10 ? currentPage : currentPage + 1);
    }
  } catch (error) {
    toast.error("Error fetching slides data", {
      position: "top-right",
      autoClose: 3000,
    });
  }
};

const fetchDocumentsData = async () => {
  try {
    const response = await fetch(
      `${historyUrl}/api/v1/data/slidedisplay/history-document/${userId}?page=${currentPage}&limit=10`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    const result = await response.json();

    if (!Array.isArray(result.data)) {
      console.warn("No documents data found.");
      setDocumentsData([]);
      return;
    }

    // Set documents data
    setDocumentsData(result.data);
  } catch (error) {
    toast.error("Error fetching documents data", {
      position: "top-right",
      autoClose: 3000,
    });
  }
};

const fetchData = async () => {
  setIsLoading(true);
  await Promise.all([fetchSlidesData(), fetchDocumentsData()]);
  setIsLoading(false);
};

    fetchData();
    const getPricingData = async () => {
      const ipInfoResponse = await fetch("https://api.zynth.ai/api/v1/data/userprofile/ip-info");
      const ipInfoData: IpInfoResponse = await ipInfoResponse.json();

      await axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/appscripts/razorpay/plans`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          const country = ipInfoData!.country!;

          if (country !== "IN" && country !== "India" && country !== "In") {
            setMonthlyPlan(response.data.items[4]);
            setYearlyPlan(response.data.items[2]);
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency("USD");
            sessionStorage.setItem("currency", "USD");
          } else if (
            country === "IN" ||
            country === "India" ||
            country === "In"
          ) {
            setMonthlyPlan(response.data.items[5]);
            setYearlyPlan(response.data.items[3]);
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency("INR");
            sessionStorage.setItem("currency", "INR");
          }
        });
    };

    const fetchUserPlan = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        const planName = response.data.plan.plan_name;
        const subscriptionId = response.data.plan.subscriptionId;
        dispatch(setUserPlan(planName));
        setSubId(subscriptionId);
      } catch (error) {
        console.error("Error fetching user plan:", error);
      }
    };

    fetchUserPlan();
    getPricingData();
  }, [userId, historyUrl, authToken, currentPage]);

  // Apply Filter and Sort Logic
  useEffect(() => {
    let updatedData: any[] = [];

    // Use appropriate data source based on active tab
    if (activeTab === 'slides') {
      updatedData = [...historyData];
    } else if (activeTab === 'docs') {
      updatedData = [...documentsData];
    }

    // Apply additional filters
    if (selectedFilter !== "all") {
      updatedData = updatedData.filter(
        (item) => item.ppt_type === selectedFilter
      );
    }

    if (selectedSort === "recent") {
      updatedData.sort(
        (a, b) =>
          new Date(b.currentTime).getTime() - new Date(a.currentTime).getTime()
      );
    } else if (selectedSort === "oldest") {
      updatedData.sort(
        (a, b) =>
          new Date(a.currentTime).getTime() - new Date(b.currentTime).getTime()
      );
    }

    setFilteredData(updatedData);
  }, [selectedFilter, selectedSort, historyData, documentsData, activeTab]);

  const monthlyPlanAmount = monthlyPlan?.item.amount! / 100;
  const monthlyPlanId = monthlyPlan?.id;
  const yearlyPlanAmount = yearlyPlan?.item.amount! / 100;
  const yearlyPlanId = yearlyPlan?.id;

  const checkVisibility = useCallback(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = parseInt(entry.target.getAttribute("data-index") || "");
          if (!isNaN(index)) {
            setVisibleSlides((prev) => {
              const newSet = new Set(prev);
              if (entry.isIntersecting) {
                newSet.add(index);
              } else {
                newSet.delete(index);
              }
              return newSet;
            });
          }
        });
      },
      {
        root: null,
        rootMargin: "50px",
        threshold: 0.1,
      }
    );

    const slides =
      containerRef.current.getElementsByClassName("slide-container");
    Array.from(slides).forEach((slide) => observer.observe(slide));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = checkVisibility();
    return () => observer?.();
  }, [checkVisibility]);

  return (
    <>
      {isLoading ? (
        <div className="w-full min-h-screen flex items-start ">
         <div className="space-y-4 w-full">
      {[...Array(10)].map((_, index) => (
        <div
          key={index}
          className="grid grid-cols-5 items-center gap-6 w-full animate-pulse"
        >
          {/* Image / Thumbnail */}
          <div className="h-20 bg-gray-300 rounded-md"></div>

          {/* Title */}
          <div className="h-4 bg-gray-300 rounded w-3/4"></div>

          {/* Subtitle */}
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>

          {/* Date */}
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>

          {/* Status / Action */}
          <div className="h-4 bg-gray-300 rounded w-1/3"></div>
        </div>
      ))}
    </div>
        </div>
      ) : (
        <div className="p-4 py-7 bg-[#F5F7FA] min-h-screen relative">
          {/* Heading Section with Tabs */}
          <div className="mb-8">
            {/* Title and Filter/Sort Controls */}
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-3xl font-bold text-[#091220]">History</h1>
              <div className="flex gap-4">
                <div className="flex gap-4 lg:hidden">
                  <div
                    className="bg-white p-2 rounded-md shadow cursor-pointer"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <FaFilter className="text-[#5D5F61] text-xl" />
                  </div>
                  <div
                    className="bg-white p-2 rounded-md shadow cursor-pointer"
                    onClick={() => setIsSortModalOpen(true)}
                  >
                    <FaSort className="text-[#5D5F61] text-xl" />
                  </div>
                </div>

                {/* Filter and Sort for Large Screens */}
                <div className="hidden lg:flex gap-4">
                  <div className="flex items-center gap-2">
                    <span className="text-[#5D5F61]">Filter by</span>
                    <select
                      className="bg-white p-2 w-fit text-[#8A8B8C] text-sm rounded-md border border-[#E1E3E5]"
                      value={selectedFilter}
                      onChange={(e) => setSelectedFilter(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="Pitch Deck">Pitch Deck</option>
                      <option value="Product">Product</option>
                      <option value="Sales Deck">Sales Deck</option>
                      <option value="Marketing">Marketing</option>
                      <option value="Business">Business</option>
                      <option value="Company Overview">Company Overview</option>
                      <option value="Project Proposal">Project Proposal</option>
                    </select>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-[#5D5F61]">Sort by</span>
                    <select
                      className="bg-white p-2 w-fit text-[#8A8B8C] text-sm rounded-md border border-[#E1E3E5]"
                      value={selectedSort}
                      onChange={(e) => setSelectedSort(e.target.value)}
                    >
                      <option value="recent">Recent First</option>
                      <option value="oldest">Oldest First</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Beautiful Tab Navigation */}
            <div className="bg-white rounded-xl shadow-sm p-2 inline-flex gap-2">
              <button
                onClick={() => setActiveTab('slides')}
                className={`flex items-center gap-3 px-6 py-3 rounded-lg transition-all duration-300 font-medium ${
                  activeTab === 'slides'
                    ? 'bg-[#3667B2] text-white shadow-lg shadow-[#3667B2]/25 transform scale-105'
                    : 'text-[#5D5F61] hover:bg-gray-50 hover:text-[#3667B2]'
                }`}
              >
                <FaChartBar className={`text-lg ${activeTab === 'slides' ? 'text-white' : 'text-[#3667B2]'}`} />
                <span className="text-base">Slides</span>
                {activeTab === 'slides' && (
                  <div className="bg-white/20 text-white text-xs px-2 py-1 rounded-full">
                    {historyData.length}
                  </div>
                )}
              </button>
              <button
                onClick={() => setActiveTab('docs')}
                className={`flex items-center gap-3 px-6 py-3 rounded-lg transition-all duration-300 font-medium ${
                  activeTab === 'docs'
                    ? 'bg-[#3667B2] text-white shadow-lg shadow-[#3667B2]/25 transform scale-105'
                    : 'text-[#5D5F61] hover:bg-gray-50 hover:text-[#3667B2]'
                }`}
              >
                <FaFileAlt className={`text-lg ${activeTab === 'docs' ? 'text-white' : 'text-[#3667B2]'}`} />
                <span className="text-base">Docs</span>
                {activeTab === 'docs' && (
                  <div className="bg-white/20 text-white text-xs px-2 py-1 rounded-full">
                    {documentsData.length}
                  </div>
                )}
              </button>
            </div>
          </div>

              {/* Mobile Sort Modal */}
              {isSortModalOpen && (
                <div className="fixed inset-0 z-50 flex justify-center items-end lg:hidden">
                  {/* Dimmed Background */}
                  <div
                    className="absolute inset-0 bg-gray-900 bg-opacity-50"
                    onClick={() => setIsSortModalOpen(false)}
                  ></div>

                  {/* Modal Content */}
                  <div className="relative bg-white w-full rounded-t-lg shadow-lg px-4 pb-4 pt-6 h-[30vh] overflow-y-auto scrollbar-none">
                    {/* Close Icon */}
                    <div
                      className="absolute top-5 right-4 bg-gray-200 rounded-full p-2 cursor-pointer"
                      onClick={() => setIsSortModalOpen(false)}
                    >
                      <FaTimes className="text-[#888a8f] text-lg" />
                    </div>
                    {/* Sort Options */}
                    <div className="flex flex-col gap-4">
                      <p
                        className={`text-[#091220] text-lg cursor-pointer ${
                          selectedSort === "recent" ? "font-semibold" : ""
                        }`}
                        onClick={() => {
                          setSelectedSort("recent");
                          setIsSortModalOpen(false);
                        }}
                      >
                        Recent First
                      </p>
                      <p
                        className={`text-[#091220] text-lg cursor-pointer ${
                          selectedSort === "oldest" ? "font-semibold" : ""
                        }`}
                        onClick={() => {
                          setSelectedSort("oldest");
                          setIsSortModalOpen(false);
                        }}
                      >
                        Oldest First
                      </p>
                    </div>
                  </div>
                </div>
              )}

          {/* Content based on active tab */}
          {activeTab === 'slides' ? (
            /* Slides content */
            <>
              {/* History Container */}
              {filteredData?.length === 0 && !isLoading ? (
                <div className="text-center relative top-24 flex flex-col items-center justify-center py-10">
                  <p className="text-lg text-[#091220] font-semibold">
                    No presentations to see here. Generate your first presentation
                    using Zynth.
                  </p>
                  <button
                    className="mt-4 bg-[#3667B2] hover:bg-white hover:text-[#3667B2] hover:border hover:border-[#3667B2] active:scale-95 transition transform duration-300 text-white px-4 py-2 rounded-md"
                    onClick={() => navigate("/new-presentation")}
                  >
                    <span className="hidden sm:inline">Generate Presentation</span>
                    <span className="sm:hidden">Generate</span>
                  </button>
                </div>
              ) : (
            <div className="bg-white mt-10 lg:mt-0 shadow-sm rounded-xl mb-2">
              {/* Mobile/Small Screen Layout */}
              <div className="grid grid-cols-1 gap-4 md:hidden">
             {filteredData?.map((item, index) =>(
                  <div
                    key={index}
                    data-testid="presentation-item"
                    className="grid grid-cols-[auto,1fr] items-center p-4 relative gap-8"
                  >
                    {/* Thumbnail Container */}
                    <div className="relative w-[8rem] h-[6rem]">
                      {/* Invisible clickable overlay */}
                      <div
                        onClick={() => handleEdit(item.FormID, item.pptName)}
                        className="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
                      ></div>
                      {/* Embedded Google Slides iframe */}
                      <iframe
                        src={`https://docs.google.com/presentation/d/${getSheetIdFromUrl(
                          item.PresentationURL
                        )}/embed?rm=minimal&start=false`}
                        title={item.pptName}
                        className="absolute top-0 left-0 w-full h-full object-cover"
                        style={{ border: "none", pointerEvents: "none" }} // Disable pointer events on the iframe
                      />
                    </div>

                    {/* Content Section */}
                    <div className="flex flex-col justify-between w-full">
                      <div className="flex justify-between items-center">
                        <h2 className="text-lg font-medium text-[#091220]">
                          {item.pptName}
                        </h2>
                        {/* Ellipsis Icon */}
                        <FaEllipsisV
                          className="text-[#8A8B8C] cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveDropdown((prev) =>
                              prev === index ? null : index
                            );
                            if (item.paymentStatus !== 0) {
                              setIsPaid(true);
                            }
                            setDocumentID(item.FormID);
                          }}
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-4 text-sm mt-3">
                        <div>
                          <span className="block mb-1 font-medium text-[#5D5F61]">
                            PPT Type
                          </span>
                          <span className="text-[#091220]">
                            {item.ppt_type}
                          </span>
                        </div>
                        <div>
                          <span className="block mb-1 font-medium text-[#5D5F61]">
                            Date
                          </span>
                          <span className="text-[#091220]">
                            {new Date(item.currentTime).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Dropdown */}
                    {activeDropdown === index && (
                      <div
                        ref={dropdownRef} // Attach the ref here
                        className="absolute right-0 top-[50%] transform -translate-y-1/2 mt-2 w-40 bg-white rounded-lg shadow-lg z-50 p-4"
                      >
                        <button
                          onClick={() => handleEdit(item.FormID, item.pptName)}
                          className="flex items-center gap-3 text-base text-[#5D5F61] mb-3 cursor-pointer"
                        >
                          <FaEdit className="text-[#5D5F61]" />
                          <span>Edit</span>
                        </button>
                        <button
                          onClick={() => handleShare()}
                          className="flex items-center gap-3 text-base text-[#5D5F61] mb-3 cursor-pointer"
                        >
                          <FaShareAlt className="text-[#5D5F61]" />
                          <span>Share</span>
                        </button>
                        <div className={`relative`}>
                          <button
                            className={`flex items-center gap-3 text-base text-[#5D5F61] mb-2 cursor-pointer ${
                              userPlan === "free" && item.paymentStatus === 0
                                ? "cursor-not-allowed opacity-50"
                                : ""
                            }`}
                            onClick={async () => {
                              const response = await axios.get(
                                `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
                                {
                                  headers: {
                                    Authorization: `Bearer ${authToken}`,
                                  },
                                }
                              );
                              if (response.status !== 200) {
                                console.error(
                                  "Non-200 response:",
                                  response.status
                                );
                                return;
                              }
                              const bundle = response.data.bundle;
                              let exportStatus = item.exportstatus;
                              const exportStatusresponse = await axios.get(
                                `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/statuscheck/${item.FormID}`,
                                {
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${authToken}`,
                                  },
                                }
                              );

                              if (exportStatusresponse.status === 200) {
                                exportStatus =
                                  exportStatusresponse.data?.data?.exportstatus ||
                                  exportStatus;
                              }

                              if (
                                userPlan === "free" &&
                                item.paymentStatus === 0 &&
                                bundle <= 0
                              ) {
                                exportStatus
                                  ? setIsDiscounted(true)
                                  : setIsDiscounted(false);
                                openPricingModal();
                                setPricingModalHeading("Google Slides");
                              } else if (
                                userPlan === "free" &&
                                item.paymentStatus === 1 &&
                                bundle <= 0
                              ) {
                                handleDownload();
                              } else {
                                handleDownload(true);
                              }
                            }}
                          >
                            <FaGoogleDrive className="text-[#5D5F61]" />
                            <span>Google Slides</span>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Medium/Large Screen Layout */}
              <div className="hidden min-h-full md:block">
         {filteredData?.map((item, index) =>(
                  <div
                    key={index}
                    data-testid="presentation-item"
                    className="grid grid-cols-[auto,1fr,1fr,1fr,auto] items-center p-4 py-6 relative gap-x-4 lg:gap-x-6"
                  >
                    {/* Thumbnail Container */}
                    <div className="relative w-[12rem] h-[7rem] overflow-hidden">
                      {/* Invisible clickable overlay */}
                      <HistoryThumbnail
                        item={item}
                        onEdit={handleEdit}
                        isVisible={visibleSlides.has(index)}
                      />

                      {/* Embedded Google Slides iframe */}
                      <iframe
                        src={`https://docs.google.com/presentation/d/${getSheetIdFromUrl(
                          item.PresentationURL
                        )}/embed?rm=minimal&slide=id.p&start=false`}
                        title={item.pptName}
                        className="absolute top-0 left-0 w-full h-full object-cover"
                        style={{ border: "none", pointerEvents: "none" }} // Disable pointer events on the iframe
                      />
                    </div>

                    {/* Title */}
                    <div className="text-lg font-bold pl-6 text-[#091220]">
                      {item.pptName}
                    </div>

                    {/* PPT Type */}
                    <div className="text-sm flex flex-col">
                      <span className="font-medium text-[#5D5F61] mr-2">
                        PPT Type:
                      </span>
                      <span className="text-[#091220] font-medium">
                        {item.ppt_type}
                      </span>
                    </div>

                    {/* Date */}
                    <div className="text-sm flex flex-col">
                      <span className="font-medium text-[#5D5F61] mr-2">
                        Date:
                      </span>
                      <span className="text-[#091220] font-medium">
                        {new Date(item.currentTime).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )}
                      </span>
                    </div>

                    {/* Ellipsis Icon */}
                    <div className="flex justify-end">
                      <FaEllipsisV
                        className="text-[#8A8B8C] cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveDropdown((prev) =>
                            prev === index ? null : index
                          );
                          if (item.paymentStatus !== 0) {
                            setIsPaid(true);
                          }
                          setDocumentID(item.FormID);
                        }}
                      />
                    </div>

                    {/* Dropdown */}
                    {activeDropdown === index && (
                      <div className="absolute right-0 top-[50%] mt-2 w-40 bg-white rounded-lg shadow-lg z-50 p-4">
                        <button
                          onClick={() => handleEdit(item.FormID, item.pptName)}
                          className="flex items-center gap-3 text-base text-[#5D5F61] mb-3 cursor-pointer"
                        >
                          <FaEdit className="text-[#5D5F61]" />
                          <span>Edit</span>
                        </button>
                        <button
                          onClick={() => handleShare()}
                          className="flex items-center gap-3 text-base text-[#5D5F61] mb-3 cursor-pointer"
                        >
                          <FaShareAlt className="text-[#5D5F61]" />
                          <span>Share</span>
                        </button>
                        <div className="relative">
                          <button
                            onClick={async () => {
                              const response = await axios.get(
                                `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
                                {
                                  headers: {
                                    Authorization: `Bearer ${authToken}`,
                                  },
                                }
                              );
                              if (response.status !== 200) {
                                console.error(
                                  "Non-200 response:",
                                  response.status
                                );
                                return;
                              }
                              const bundle = response.data.bundle;
                              let exportStatus = item.exportstatus;
                              const exportStatusresponse = await axios.get(
                                `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/statuscheck/${item.FormID}`,
                                {
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${authToken}`,
                                  },
                                }
                              );

                              if (exportStatusresponse.status === 200) {
                                exportStatus =
                                exportStatusresponse.data?.data?.exportstatus ||
                                  exportStatus;
                              }

                              if (
                                userPlan === "free" &&
                                item.paymentStatus === 0 &&
                                bundle <= 0
                              ) {
                                exportStatus
                                  ? setIsDiscounted(true)
                                  : setIsDiscounted(false);
                                openPricingModal();
                                setPricingModalHeading("Google Slides");
                              } else if (
                                userPlan === "free" &&
                                item.paymentStatus === 1
                              ) {
                                handleDownload();
                              } else {
                                handleDownload(true);
                              }
                            }}
                            className={`flex items-center gap-3 text-base text-[#5D5F61] mb-2 cursor-pointer`}
                          >
                            <FaGoogleDrive className="text-[#5D5F61]" />
                            <span>Google Slides</span>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Pricing modal removed — redirect to the /pricing page in a new tab when upgrade/top-up is required */}

          <PaymentGateway
            key={isBundle ? "bundle-a" : "single-a"}
            productinfo="Presentation Export"
            onSuccess={handleDownload}
            formId={documentID!}
            authToken={authToken!}
            isDiscounted={isDiscounted}
            discountedAmount={
              isBundle ? bundleDiscountedAmount : discountedAmount
            }
            originalAmount={isBundle ? bundleCurrentAmount : currentAmount}
          />
          {/* Pagination */}
{totalPages > 1 && (
  <div className="flex justify-between items-center mt-6">
    <button
      className="flex gap-2 items-center hover:scale-105 px-4 py-2 active:scale-95 transition transform duration-300 rounded-md disabled:bg-[#ffffff] disabled:cursor-not-allowed disabled:hover:scale-100"
      disabled={currentPage === 1}
      onClick={() => setCurrentPage((prev) => prev - 1)}
    >
      <FaArrowLeft />
      <span className="hidden sm:inline">Previous</span>
    </button>

    <span>
      Page {currentPage} of {totalPages}
    </span>

    <button
      className="flex gap-2 items-center hover:scale-105 active:scale-95 transition transform duration-300 px-4 py-2 rounded-md disabled:bg-[#ffffff] disabled:cursor-not-allowed disabled:hover:scale-100"
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage((prev) => prev + 1)}
    >
      <span className="hidden sm:inline">Next</span>
      <FaArrowRight />
    </button>
  </div>
)}

              </>
            ) : (
              /* Docs content */
              <>
                {filteredData?.length === 0 && !isLoading ? (
                  <div className="flex flex-col items-center justify-center py-20">
                    <div className="bg-white rounded-2xl shadow-lg p-12 max-w-2xl mx-auto text-center">
                      <div className="mb-8">
                        <div className="w-24 h-24 bg-gradient-to-br from-[#3667B2] to-[#4c7cd1] rounded-full flex items-center justify-center mx-auto mb-6">
                          <FaFileAlt className="text-4xl text-white" />
                        </div>
                        <h2 className="text-3xl font-bold text-[#091220] mb-4">
                          No Documents Yet
                        </h2>
                        <p className="text-lg text-[#5D5F61] mb-8 leading-relaxed">
                          You haven't created any documents yet. Start creating your first document to see it here.
                        </p>
                      </div>
                      
                      <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button
                          onClick={() => navigate("/new-document")}
                          className="bg-[#3667B2] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#2c56a0] transform hover:scale-105 transition-all duration-300 shadow-lg"
                        >
                          Create New Document
                        </button>
                        <button
                          onClick={() => setActiveTab('slides')}
                          className="border border-[#3667B2] text-[#3667B2] px-8 py-3 rounded-lg font-semibold hover:bg-[#3667B2] hover:text-white transform hover:scale-105 transition-all duration-300"
                        >
                          View Presentations
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {filteredData
                      ?.slice((currentPage - 1) * 10, currentPage * 10)
                      ?.map((item, index) => (
                      <div
                        key={item.FormID}
                        className="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 relative group"
                      >
                        {/* Document Preview */}
                        <div className="relative h-48 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-t-lg overflow-hidden">
                          <div className="absolute inset-0 flex items-center justify-center">
                            <FaFileAlt className="w-16 h-16 text-blue-400" />
                          </div>
                          
                          {/* Overlay with actions */}
                          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-200 flex items-center justify-center opacity-0 group-hover:opacity-100">
                            <div className="flex space-x-3">
                              <button
                                onClick={() => handleEdit(item.FormID, item.pptName, item.ppt_type)}
                                className="bg-white text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors flex items-center space-x-2"
                              >
                                <FaEdit className="w-4 h-4" />
                                <span>Edit</span>
                              </button>
                              {/* <button
                                onClick={() => {
                                  setDocumentID(item.FormID);
                                  setIsPaid(item.paymentStatus === 1);
                                  setPricingModalHeading(item.pptName);
                                  openPricingModal();
                                }}
                                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
                              >
                                <FaGoogleDrive className="w-4 h-4" />
                                <span>Export</span>
                              </button> */}
                            </div>
                          </div>
                        </div>

                        {/* Document Info */}
                        <div className="p-4">
                          <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2">
                            {item.pptName}
                          </h3>
                          <div className="flex items-center justify-between text-sm text-gray-500">
                            <span className="flex items-center space-x-1">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              <span>{new Date(item.currentTime).toLocaleDateString()}</span>
                            </span>
                            <span className={`px-2 py-1 rounded-full text-xs ${
                              item.paymentStatus === 1
                                ? 'bg-green-100 text-green-800'
                                : 'bg-yellow-100 text-yellow-800'
                            }`}>
                              {item.paymentStatus === 1 ? 'Exported' : 'Draft'}
                            </span>
                          </div>
                        </div>

                        {/* Dropdown Menu */}
                        <div className="absolute top-3 right-3">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveDropdown(activeDropdown === index ? null : index);
                            }}
                            className="bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-2 shadow-sm transition-all duration-200"
                          >
                            <FaEllipsisV className="w-4 h-4 text-gray-600" />
                          </button>

                          {activeDropdown === index && (
                            <div
                              ref={dropdownRef}
                              className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 z-50"
                            >
                              <button
                                onClick={() => {
                                  handleEdit(item.FormID, item.pptName, item.ppt_type);
                                  setActiveDropdown(null);
                                }}
                                className="flex items-center space-x-3 w-full px-4 py-3 text-left text-gray-700 hover:bg-gray-50 transition-colors"
                              >
                                <FaEdit className="w-4 h-4" />
                                <span>Edit Document</span>
                              </button>
                              {/* <button
                                onClick={() => {
                                  setDocumentID(item.FormID);
                                  setIsPaid(item.paymentStatus === 1);
                                  setPricingModalHeading(item.pptName);
                                  openPricingModal();
                                  setActiveDropdown(null);
                                }}
                                className="flex items-center space-x-3 w-full px-4 py-3 text-left text-gray-700 hover:bg-gray-50 transition-colors"
                              >
                                <FaGoogleDrive className="w-4 h-4" />
                                <span>Export Document</span>
                              </button> */}
                              <button
                                onClick={() => {
                                  setDocumentID(item.FormID);
                                  handleShare();
                                  setActiveDropdown(null);
                                }}
                                className="flex items-center space-x-3 w-full px-4 py-3 text-left text-gray-700 hover:bg-gray-50 transition-colors border-t border-gray-100"
                              >
                                <FaShareAlt className="w-4 h-4" />
                                <span>Share Document</span>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}


          {/* Mobile Filter Modal */}
          {isModalOpen && (
            <div className="fixed inset-0 z-50 flex justify-center items-end lg:hidden">
              {/* Dimmed Background */}
              <div
                className="absolute inset-0 bg-gray-900 bg-opacity-50"
                onClick={() => setIsModalOpen(false)}
              ></div>

              {/* Modal Content */}
              <div className="relative bg-white w-full rounded-t-lg shadow-lg px-4 pb-4 pt-6 h-[30vh] overflow-y-auto scrollbar-none">
                {/* Close Icon */}
                <div
                  className="absolute top-5 right-4 bg-gray-200 rounded-full p-2 cursor-pointer"
                  onClick={() => setIsModalOpen(false)}
                >
                  <FaTimes className="text-[#888a8f] text-lg" />
                </div>
                {/* Links */}
                <div className="flex flex-col gap-4">
                  <p
                    className="text-[#091220] text-lg"
                    onClick={() => {
                      setSelectedFilter("Pitch Deck");
                      setIsModalOpen(false);
                    }}
                  >
                    Pitch Deck
                  </p>
                  <p
                    className="text-[#091220] text-lg"
                    onClick={() => {
                      setSelectedFilter("Product");
                      setIsModalOpen(false);
                    }}
                  >
                    Product
                  </p>
                  <p
                    className="text-[#091220] text-lg"
                    onClick={() => {
                      setSelectedFilter("Sales Deck");
                      setIsModalOpen(false);
                    }}
                  >
                    Sales Deck
                  </p>
                  <p
                    className="text-[#091220] text-lg"
                    onClick={() => {
                      setSelectedFilter("Marketing");
                      setIsModalOpen(false);
                    }}
                  >
                    Marketing
                  </p>
                  <p
                    className="text-[#091220] text-lg"
                    onClick={() => {
                      setSelectedFilter("Business");
                      setIsModalOpen(false);
                    }}
                  >
                    Business
                  </p>
                  <p
                    className="text-[#091220] text-lg"
                    onClick={() => {
                      setSelectedFilter("Company Overview");
                      setIsModalOpen(false);
                    }}
                  >
                    Company Overview
                  </p>
                  <p
                    className="text-[#091220] text-lg"
                    onClick={() => {
                      setSelectedFilter("Project Proposal");
                      setIsModalOpen(false);
                    }}
                  >
                    Project Proposal
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default HistoryContainer;
